import { listBotsService } from '../../../services/boteria/listBots';

export function listBotsActions (token, tokenPartners) { 
	return {
		type: 'LIST_BOTS',
		payload: listBotsService(token, tokenPartners)
	}
}